// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.newsletter-page {
  background: var(--bg-primary);
  padding-top: 80px;
  display: flex;
  justify-content: center;
}

.newsletter-container {
  max-width: 500px;
  width: 100%;
  padding: 2rem 1.5rem;
  text-align: center;
}

.newsletter-title {
  font-size: 2rem;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 0.75rem;
}

.newsletter-description {
  color: var(--text-secondary);
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0 0 0.5rem;
}

.newsletter-frequency-hint {
  color: var(--text-secondary);
  font-size: 0.85rem;
  line-height: 1.5;
  margin: 0 0 2rem;
  opacity: 0.9;
}

.newsletter-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.newsletter-input {
  width: 100%;
  padding: 0.8rem 1rem;
  font-size: 1rem;
  background: var(--bg-secondary);
  color: var(--text-primary);
  border: 2px solid var(--border-primary);
  border-radius: 10px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.newsletter-input:focus {
  outline: none;
  border-color: var(--accent-primary);
}

.newsletter-actions {
  display: flex;
  gap: 0.75rem;
}

.newsletter-btn {
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-subscribe {
  background: var(--accent-primary);
  color: white;
}

.btn-subscribe:hover:not(:disabled) {
  background: var(--accent-hover);
}

.btn-unsubscribe {
  background: var(--bg-tertiary);
  color: var(--text-primary);
}

.btn-unsubscribe:hover:not(:disabled) {
  background: var(--border-secondary);
}

.newsletter-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.newsletter-message {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.85rem;
  font-weight: 500;
}

.newsletter-message.success {
  background: rgba(16, 185, 129, 0.1);
  color: var(--success);
  border: 1px solid var(--success);
}

.newsletter-message.error {
  background: rgba(239, 68, 68, 0.1);
  color: var(--error);
  border: 1px solid var(--error);
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewsletterPage.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,0BAA0B;EAC1B,uCAAuC;EACvC,mBAAmB;EACnB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":[".newsletter-page {\n  background: var(--bg-primary);\n  padding-top: 80px;\n  display: flex;\n  justify-content: center;\n}\n\n.newsletter-container {\n  max-width: 500px;\n  width: 100%;\n  padding: 2rem 1.5rem;\n  text-align: center;\n}\n\n.newsletter-title {\n  font-size: 2rem;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 0.75rem;\n}\n\n.newsletter-description {\n  color: var(--text-secondary);\n  font-size: 0.95rem;\n  line-height: 1.6;\n  margin: 0 0 0.5rem;\n}\n\n.newsletter-frequency-hint {\n  color: var(--text-secondary);\n  font-size: 0.85rem;\n  line-height: 1.5;\n  margin: 0 0 2rem;\n  opacity: 0.9;\n}\n\n.newsletter-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.newsletter-input {\n  width: 100%;\n  padding: 0.8rem 1rem;\n  font-size: 1rem;\n  background: var(--bg-secondary);\n  color: var(--text-primary);\n  border: 2px solid var(--border-primary);\n  border-radius: 10px;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.newsletter-input:focus {\n  outline: none;\n  border-color: var(--accent-primary);\n}\n\n.newsletter-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.newsletter-btn {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: none;\n  border-radius: 10px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-subscribe {\n  background: var(--accent-primary);\n  color: white;\n}\n\n.btn-subscribe:hover:not(:disabled) {\n  background: var(--accent-hover);\n}\n\n.btn-unsubscribe {\n  background: var(--bg-tertiary);\n  color: var(--text-primary);\n}\n\n.btn-unsubscribe:hover:not(:disabled) {\n  background: var(--border-secondary);\n}\n\n.newsletter-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.newsletter-message {\n  padding: 0.75rem 1rem;\n  border-radius: 8px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.newsletter-message.success {\n  background: rgba(16, 185, 129, 0.1);\n  color: var(--success);\n  border: 1px solid var(--success);\n}\n\n.newsletter-message.error {\n  background: rgba(239, 68, 68, 0.1);\n  color: var(--error);\n  border: 1px solid var(--error);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
